import { useCallback, useState } from 'react';

export const useModalState = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleModal = useCallback(() => setIsOpen((oldVal) => !oldVal), []);

  return { isOpen, openModal, closeModal, toggleModal };
};
